module.exports = __webpack_public_path__ + "static/share-image-702787dda97c475586254c74ca6e1878.png";